import type { Components, Theme } from '@mui/material/styles';

export function dataOverrides(theme: Theme): Components<Theme> {
  const mobile = theme.breakpoints.down('sm');

  return {
    MuiTableCell: {
      styleOverrides: {
        root: {
          borderBottomColor: theme.palette.divider,
          padding: '8px 12px',
          fontSize: '0.8125rem',
          fontVariantNumeric: 'tabular-nums',
        },
        head: {
          fontWeight: 600,
          fontSize: '0.6875rem',
          textTransform: 'uppercase',
          letterSpacing: '0.06em',
          color: theme.palette.text.secondary,
          backgroundColor: theme.palette.background.elevated,
          whiteSpace: 'nowrap',
        },
        sizeSmall: { padding: '6px 12px' },
      },
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          height: 36,
          '&:last-of-type td': { borderBottom: 'none' },
          '&.MuiTableRow-hover:hover': { backgroundColor: theme.palette.background.elevated },
          [theme.breakpoints.only('sm')]: { height: 40 },
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: 4,
          fontWeight: 600,
          height: 20,
          fontSize: '0.75rem',
          [mobile]: { height: 24 },
        },
        sizeSmall: { height: 20, fontSize: '0.75rem', [mobile]: { height: 24 } },
        label: { paddingInline: theme.spacing(1.5) },
      },
    },
    MuiLinearProgress: {
      styleOverrides: { root: { borderRadius: 0, height: 2, backgroundColor: theme.palette.background.elevated } },
    },
    MuiDialog: {
      defaultProps: { transitionDuration: { enter: 250, exit: 250 } },
      styleOverrides: {
        paper: {
          borderRadius: 6,
          boxShadow: '0 4px 12px rgba(0,0,0,0.4)',
          backgroundImage: 'none',
          backgroundColor: theme.palette.background.paper,
        },
        paperFullScreen: { borderRadius: 0 },
      },
    },
    MuiDialogTitle: {
      styleOverrides: {
        root: {
          fontSize: '1rem',
          fontWeight: 600,
          padding: theme.spacing(3, 4),
        },
      },
    },
    MuiDialogActions: {
      styleOverrides: {
        root: {
          padding: theme.spacing(3, 4),
          [mobile]: {
            position: 'sticky',
            bottom: 0,
            backgroundColor: theme.palette.background.paper,
            borderTop: `1px solid ${theme.palette.divider}`,
          },
        },
      },
    },
    MuiSnackbar: {
      defaultProps: { autoHideDuration: 4000, anchorOrigin: { vertical: 'bottom', horizontal: 'right' } },
    },
  };
}
